<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-col md="4" order="1">
        <h3>
          <b-badge variant="primary">
            Location Details
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col md="4" order="3" order-md="2">
        <b-button 
          block 
          target="_blank" 
          :disabled="waiting"
          :href="googleMapsLink"
          variant="success">
          Open in google maps
        </b-button>
      </b-col>
      <b-col md="4" order="2" order-md="3" class="pb-md-0 pb-2">
        <b-button block @click="$router.push({path: '/'})">
          Back
        </b-button>
      </b-col>
    </b-row>
    <template v-if="Object.keys(item).length > 0">
      <b-row v-for="(field, index) in fields" :key="index">
        <b-col :class="{ odd: (index % 2 == 0) }">
          <strong>{{ field.label }}</strong>
        </b-col>
        <b-col :class="{ odd: (index % 2 == 0) }">
          {{ item[field.key] }}
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'LocationDetails',
  data() {
    return {
      waiting: false,
      HHID: '',
      item: {},
      fields: [
        {
          key: 'HHID',
          label: 'Household ID'
        },
        {
          key: 'FamilyName',
          label: 'Family Name'
        },
        {
          key: 'ResidenceNumberAndName',
          label: 'Apartment number and building or complex name'
        },
        {
          key: 'StreetAddress',
          label: 'Street Address'
        },
        {
          key: 'TownOrCity',
          label: 'Town or City'
        },
        {
          key: 'Province',
          label: 'Province'
        },
        {
          key: 'PostalCode',
          label: 'Postal Code'
        },
        {
          key: 'LocationDescription',
          label: 'Description of how to find the location, access requirements and who to talk to'
        },
        {
          key: 'ConfirmHouseholdNumber',
          label: 'Confirm Household Number'
        },
        {
          key: 'Latitude',
          label: 'Latitude'
        },
        {
          key: 'Longitude',
          label: 'Longitude'
        },
      ]
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    apiService.getLocation(this.HHID)
    .then((response) => {
      vm.item = response.data
      vm.waiting = false
    })
  },
  computed: {
    googleMapsLink() {
      let zoom = '16'
      let mapType = 'm'
      let baseLink = 'https://www.google.com/maps'
      let lat = this.item.Latitude
      let long = this.item.Longitude
      return `${baseLink}?z=${zoom}&t=${mapType}&q=loc:${lat}+${long}`
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/LocationDetailsPage.vue